import { z } from 'zod';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const feriadoInputSchema = z.object({
  data: z.string().regex(ISO_DATE, 'Formato esperado: YYYY-MM-DD'),
  nome: z.string().trim().min(1, 'Obrigatório').max(150, 'Máximo 150 caracteres'),
  tipo: z.enum(['NAC', 'EST', 'MUN', 'FAC', 'OUT']),
  ativo: z.boolean().optional(),
});

export type FeriadoFormValues = z.infer<typeof feriadoInputSchema>;
